import React from "react";
import {
  Button,
  FormFieldSet,
  Modal,
  useFormHandler,
} from "../../../../../../components";
import { AccountpayableAccountType } from "../../../../../../assets/data/projectData";

const MoreActionModal = ({ open, onClose }) => {
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      documentType: [],
    },
    {
      documentType: {
        type: "select",
        required: true,
      },
    }
  );
  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title="INVOICE DETAILS"
      width="max-w-2xl"
    >
      <div className="px-4">
        <div className="grid grid-cols-2">
          <FormFieldSet
            type="select"
            title="Account Type"
            placeholder="Select Account Type"
            value={formData.documentType}
            onChange={(value) => handleChange("documentType", value)}
            error={errors.documentType}
           options={AccountpayableAccountType}
          />
        </div>

        <div className="flex justify-end gap-3 my-6">
          <Button title={"No"} variant="outlined" onClick={onClose} />
          <Button title={"Yes"} onClick={() => handleSave()} />
        </div>
      </div>
    </Modal>
  );
};

export default MoreActionModal;
